export const PDF_EXTRACT_SYSTEM_PROMPT = `You extract customer quote PDF data from free-text specs pasted by a sales rep.
Return ONLY valid JSON (no markdown fences, no commentary).

When the text contains ONE product, return a single object with "products": [ one item ].
When the text contains MULTIPLE products, return ALL of them in the "products" array — one object per distinct product quote section.

This includes:
- Different types (e.g. bags AND labels) → separate products[] entries.
- Same type with DIFFERENT specs (e.g. two bag sizes, two box styles) → separate products[] entries, each with its own specsLine, dimensions, pricing, and shipping.
- Do NOT merge same-type products that have different sizes, materials, or pricing into one entry.

{
  "companyName": string or "",
  "attentionTo": string or "",
  "projectDescription": string or "",
  "products": [
    {
      "productType": "Bags"|"Boxes"|"Labels"|"Other",
      "styleNumber": string (bag style # or box #),
      "specsLine": string (single product specs line when not Labels),
      "material": string,
      "thickness": string (labels only, e.g. "120 mil"),
      "labelShape": string (labels: "Regular", "Peel off label", etc.),
      "rollingDirection": string (labels, e.g. "Hand applied"),
      "specialEffects": string (labels, e.g. "N/A"),
      "shippingMethod": string (labels shipping method note, e.g. "express air"),
      "loadingSide": string or "Top",
      "zipper": string or "",
      "finish": string,
      "bagFeatures": [string],
      "widthInches": number or null,
      "heightInches": number or null,
      "gussetInches": number or null,
      "skuCount": number,
      "quantityTiers": [number],
      "pricePerUnit": [number],
      "labelItems": [
        {
          "specsLine": string (e.g. "Etiqueta pequeña - 2 cm x 3.5 cm"),
          "skuLabel": string (e.g. "16-20" or "1"),
          "quantities": [number],
          "pricePerUnit": [number]
        }
      ],
      "orderLeadTime": string (labels only, e.g. "5-10 business days"),
      "shipping": [
        { "method": "Express Air shipping"|"Regular Air Shipping"|"Express Sea shipping"|"Regular Sea Shipping"|"Premium Air shipping", "cost": number }
      ]
    }
  ]
}

IMPORTANT — shipping costs:
- Extract ONLY Tier 1 base price in "cost". Do NOT calculate Tier 2/Tier 3.
- Each product gets its OWN shipping array from its section of the pasted text.

Rules:
- Bags: stand up pouch style #4 → productType "Bags", styleNumber "4".
- Boxes: style #2 → productType "Boxes", styleNumber "2".
- Labels / etiqueta / label roll → productType "Labels". Use labelItems for each label size/SKU group.
- When labelItems is present, flatten each qty tier into labelItems rows.
- pet/vmpet/pe → material "PET / VMPET / PE". White Bopp → "White Bopp".
- gloss lamination → finish "Gloss Lamination" or "Lamination".
- "5 SKUs" on bags/boxes → skuCount 5.
- Cost per piece tiers → quantityTiers + pricePerUnit for bags/boxes.
- specsLine: human-readable dimensions when sizes given.
- If text has clear sections (--- BAG 1 ---, --- BAG 2 ---, --- LABELS ---), extract each section as a separate products[] entry.
- specsLine: short human-readable summary of that section's size/style (e.g. "Stand up pouch 4 — 101.1 W x 127.4 H x 50.8 G"). Required when multiple products share the same productType.`;

export function buildPdfExtractUserContent(text) {
  return `CUSTOMER QUOTE SPECS:\n${text.slice(0, 12000)}\n\nExtract JSON for LabelsLab customer quote PDF now.`;
}
